import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-KbTC_jnR.js';

const tooltipCss = ":host{display:inline-flex;line-height:0;position:relative;width:fit-content}.inner{display:inline-flex}.inner,.wrapper{height:100%;width:100%}";

const _groups = {};
const WuiTooltip = /*@__PURE__*/ proxyCustomElement(class WuiTooltip extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Where to place relative to target element
         */
        this.placement = 'top';
        /**
         * When to trigger the tooltip
         *
         * Defaults to focus/hover.
         *
         * Can be set to 'none' to take manual control of opening/closing the tooltip.
         */
        this.trigger = 'focus';
        this.fixed = false;
        /**
         * Manually open/close tooltip.
         *
         * Only works when `trigger` is set to 'none'.
         */
        this.open = false;
        /**
         * When trigger is set to `'focus'`, determines how long until tooltip opens
         */
        this.timeoutOpen = 200;
        /**
         * When trigger is set to '`click`', determines how long until tooltip closes
         */
        this.timeoutClose = 1000;
        this.handleClick = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'click') {
                return;
            }
            this.setOpen(!this.open);
            if (this.timeoutClose && this.timeoutClose > 0 && this.timeoutClose !== Number.POSITIVE_INFINITY) {
                this._timeoutClose = setTimeout(() => {
                    this.setOpen(false);
                }, this.timeoutClose);
            }
        };
        this.handleFocus = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.triggerOpen();
        };
        this.handleBlur = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.setOpen(false);
        };
    }
    onChangeOpen(newValue) {
        // Ignore this prop change when not under manual control
        if (this.trigger !== 'none') {
            return;
        }
        this.setOpen(!!newValue);
    }
    componentWillLoad() {
        if (this.trigger === 'none') {
            this.open = !!this.open;
        }
    }
    getGroup() {
        if (!this.groupName) {
            return;
        }
        if (!_groups[this.groupName]) {
            _groups[this.groupName] = {
                open: false,
                timeout: undefined,
            };
        }
        return _groups[this.groupName];
    }
    setOpen(open) {
        // Clear any existing timeouts that would have otherwise opened/closed the tooltip
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutClose && window.clearTimeout(this._timeoutClose);
        this.open = open;
        const group = this.getGroup();
        if (group) {
            // Clear timeout that otherwise would have marked the group as being closed
            group.timeout && clearTimeout(group.timeout);
            if (open) {
                // Set group to open
                group.open = true;
            }
            else {
                // Wait a little bit before marking the group as closed
                group.timeout = setTimeout(() => {
                    group.open = false;
                }, 1000);
            }
        }
    }
    triggerOpen() {
        // If part of a group that's already open
        const group = this.getGroup();
        // Clear an existing timeout
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutOpen = setTimeout(() => {
            this.setOpen(true);
        }, 
        // Skip timeout if group is already open
        group?.open ? 0 : this.timeoutOpen);
    }
    render() {
        return (h(Host, { key: 'bc53d4af2504fb96d1e8e96b304c0be6a5a2909e', "aria-label": this.label }, h("div", { key: 'a04a41b9f8dc3ad647c280697028ea5403b2c9e9', class: "wrapper" }, h("wui-tooltip-label", { key: 'c26488ea592bb740b4a3f5347e68b50823818058', open: this.open, label: this.label, placement: this.placement, fixed: this.fixed }), h("div", { key: 'b23d7e0254cad761e39bdfb9a604f52919b6204a', tabIndex: -1, onClick: this.handleClick, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.handleFocus, onMouseLeave: this.handleBlur, class: "inner" }, h("slot", { key: 'd86f0aa8200cdce97ed1efbb8c1646937d88cdf4' })))));
    }
    static get watchers() { return {
        "open": ["onChangeOpen"]
    }; }
    static get style() { return tooltipCss; }
}, [257, "wui-tooltip", {
        "label": [1],
        "placement": [1],
        "trigger": [1],
        "fixed": [4],
        "open": [1540],
        "timeoutOpen": [2, "timeout-open"],
        "timeoutClose": [2, "timeout-close"],
        "groupName": [1, "group-name"],
        "disabled": [516]
    }, undefined, {
        "open": ["onChangeOpen"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTooltip);
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTooltip as W, defineCustomElement as d };
